export enum InputTypes {
	TEXT = 'text',
	EMAIL = 'email',
	PHONE = 'phone',
	PASSWORD = 'password',
	NUMBER = 'number',
	DATE = 'date',
	TIME = 'time',
	DATE_TIME_LOCAL = 'datetime-local',
	CHECKBOX = 'checkbox',
	RADIO = 'radio',
	SELECT = 'select',
	DROPDOWN = 'dropdown',
	TEXTAREA = 'textarea',
	FILE = 'file',
	IMAGE = 'image',
	COLOR = 'color',
	RANGE = 'range',
	TEL = 'tel',
	URL = 'url',
	SEARCH = 'search',
	MONTH = 'month',
	WEEK = 'week',
	HIDDEN = 'hidden',
	MULTI_SELECT = 'multi select',
	CHECKBOXES = 'checkboxes',
	EDITOR = 'editor',
	RATING = 'rating',
	MULTIPLE_FILES = 'multiple files',
}
